import React, {useEffect, useState} from 'react';
// @ts-ignore
import FroalaEditorView from 'react-froala-wysiwyg/FroalaEditorView';
import {H1} from '../components/H1';
import {H3} from '../components/H3';
import {WorksWithUsDto} from "../types/types";
import {getWorksDetail} from "../apis/contents";
import {useParams} from "react-router-dom";

export const WorkWithUsDetailPage = () => {
    const {id} = useParams<{ id: string }>()
    const numId = parseInt(id)
    const [content, setContent] = useState<WorksWithUsDto>()

    useEffect(() => {
        getWorksDetail(numId).then(r => setContent(r.data.payload)).catch(e => console.log(e))
    }, [numId])

    if (!content) return null
    return (
        <>
            <div className="max-w-screen-md mx-3 md:mx-auto mt-16">
                <div className="flex justify-between">
                    <H1 className="font-semibold hidden md:block">{content.title}</H1>
                    <H3 className="font-semibold md:hidden">{content.title}</H3>
                    <button className="filled-gray-900 px-3 py-2"
                            onClick={() => window.location.assign(content.resumeFormUrl!)}
                    >
                        지원하기
                    </button>
                </div>
                <hr className="my-7 solid"/>
                <div className="max-w-screen-lg mx-auto">
                    <FroalaEditorView model={content.content}/>
                </div>
            </div>
        </>
    );
};
